import React from 'react';
import { usePrincipleCoverageAnalysis } from '../../hooks/useComplianceData';
import { TrainingIcon } from '../TrainingIcon';

/**
 * Principle Coverage Analysis Component — groups principles into high/medium/low
 * coverage buckets derived from the compliance data.
 */
export const PrincipleCoverageAnalysis = ({ complianceData }) => {
  const { high, medium, low } = usePrincipleCoverageAnalysis(complianceData);

  return (
    <div className="trd-section">
      <div className="trd-section-head">
        <span className="trd-section-icon"><TrainingIcon name="layers" size={18} /></span>
        <div>
          <h2 className="trd-section-title">Principle Coverage Analysis</h2>
        </div>
      </div>

      <div className="trd-bucket-grid">
        <div className="trd-bucket trd-bucket--high">
          <h3 className="trd-bucket-title"><TrainingIcon name="check" size={15} />High Coverage Principles</h3>
          {high.length > 0 ? (
            high.map((principle) => (
              <div key={principle.key} className="trd-bucket-item">
                {principle.key} ({principle.title.split('(')[0].trim()}): {principle.covered} employees, {principle.workerCovered} workers covered
              </div>
            ))
          ) : (
            <div className="trd-bucket-empty">No high coverage principles</div>
          )}
        </div>

        <div className="trd-bucket trd-bucket--medium">
          <h3 className="trd-bucket-title"><TrainingIcon name="activity" size={15} />Medium Coverage Principles</h3>
          {medium.length > 0 ? (
            medium.map((principle) => (
              <div key={principle.key} className="trd-bucket-item">
                {principle.key} ({principle.title.split('(')[0].trim()}): {principle.covered} employees, {principle.workerCovered} workers covered
              </div>
            ))
          ) : (
            <div className="trd-bucket-empty">No medium coverage principles</div>
          )}
        </div>

        <div className="trd-bucket trd-bucket--low">
          <h3 className="trd-bucket-title"><TrainingIcon name="alert" size={15} />Low Coverage Principles</h3>
          {low.length > 0 ? (
            <>
              {low.map((principle) => (
                <div key={principle.key} className="trd-bucket-item">
                  {principle.key}, {(principle.covered > 0 || principle.workerCovered > 0)
                    ? `${principle.covered} employees, ${principle.workerCovered} workers covered`
                    : 'Need immediate attention'}
                </div>
              ))}
              {low.filter(p => p.covered === 0 && p.workerCovered === 0).length > 0 && (
                <div className="trd-bucket-item" style={{ marginTop: "8px", fontWeight: "500" }}>
                  {low.filter(p => p.covered === 0 && p.workerCovered === 0).length} principle(s) with no coverage
                </div>
              )}
            </>
          ) : (
            <div className="trd-bucket-empty">No low coverage principles</div>
          )}
        </div>
      </div>
    </div>
  );
};
